var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { CardIssuingApiService } from '@ClientApi/cardIssuing';
export const ALLOWED_VENDORS_QUERY_KEY_ROOT = 'ALLOWED_VENDORS';
export const ALLOWED_VENDORS_QUERY_KEY_GRID = 'GRID';
const _ALLOWED_VENDORS_PLACEHOLDER_DATA = [];
export const useAllowedVendorsQuery = () => {
    const queryInfo = useQuery([ALLOWED_VENDORS_QUERY_KEY_ROOT, ALLOWED_VENDORS_QUERY_KEY_GRID], () => __awaiter(void 0, void 0, void 0, function* () {
        return yield CardIssuingApiService.getVendors();
    }), {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        staleTime: 5000,
        placeholderData: _ALLOWED_VENDORS_PLACEHOLDER_DATA
    });
    return queryInfo;
};
